import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useStyles } from 'components/desktop/_general/Input/InputExtensions/InputTranslateButton/InputTranslateButton.tss';

interface IProps {
	name: string;
	onClick: (name: string) => void;
}

const InputTranslateButton = (props: IProps) => {
	const { classes } = useStyles();
	return (
		<span
			className={['input-group-text', classes.button].join(' ')}
			onClick={() => props.onClick(props.name)}
		>
			<FontAwesomeIcon icon={faGlobe} className={classes.icon} />
		</span>
	);
};

export default InputTranslateButton;
